import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BOItem } from '../../models/BOItem.model';
import { RelativeTypeService } from '../../services/relativeType.service';
import { Utilities } from '../../common/utilities';
//import { AfterViewInit, ChangeDetectorRef,  ElementRef, EventEmitter, OnDestroy, Output, ViewChild, NgZone} from "@angular/core";

@Component({
  selector: 'app-relative-disease',
  templateUrl: './relative-disease.component.html',
  styleUrls: ['./relative-disease.component.css']
})
export class RelativeDiseaseComponent implements OnInit, OnChanges {
    @Input() id!: number;
    @Input() relativeTypeCode!: string;
    @Input() cei10Code!: string;
    @Input() cei10Name!: string;
    @Input() posInArray!:number;
    @Input() uniqueId!: string;
   // @Output() posSended = new EventEmitter<{pos:number}>();
    @Output() posSended = new EventEmitter<{ uniqueId: string }>(); // ← Cambia el tipo
    @Output() posSendedId = new EventEmitter<{ itemId: number }>(); // ← Cambia el tipo


  relativeTypeList:BOItem[]=[];

  constructor( private _formBuilder : FormBuilder,
               private _relativeTypeService: RelativeTypeService,
  )
  { }

  relativeDiseaseGroup = this._formBuilder.group({
    posInArray:{ value: null, disabled: true },
    patientId: { value: null, disabled: true },            //patientInformationId
    relativeType: { value: null, disabled: true },
    cei10Code: { value: null, disabled: true },
    cei10Name: { value: null, disabled: true },
    cei11Code: { value: null, disabled: true },
    cei11Name: { value: null, disabled: true },
  })

  ngOnInit(): void {

    let test=Utilities.getRelativeTypeName(this.relativeTypeCode, this.relativeTypeList);
    console.log("relativeType es:", test )
    this._relativeTypeService.getAll().subscribe({
      next:(data)=>
      {
        this.relativeTypeList=data;

        this.relativeDiseaseGroup.patchValue({
        posInArray: this.posInArray +1,
        relativeType: Utilities.getRelativeTypeName(this.relativeTypeCode, this.relativeTypeList),
        cei10Code: this.cei10Code,
        cei10Name: this.cei10Name,
       })

      },
      error:(err)=>{
        console.log("Ocurrió un error en la descarga de tipo parientes");
      }
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
    // Evitamos el primer cambio porque ngOnInit ya lo maneja
    if (changes['posInArray'] && !changes['posInArray'].firstChange) {
      this.relativeDiseaseGroup.patchValue({
        posInArray: this.posInArray + 1
      });
    }
  }



    // private patchForm(): void {
    //     this.relativeDiseaseGroup.patchValue({
    //     posInArray: this.posInArray +1,
    //     relativeType: Utilities.getRelativeTypeName(this.relativeTypeCode, this.relativeTypeList),
    //     cei10Code: this.cei10Code,
    //     cei10Name: this.cei10Name,
    //    })

    // }


deleteItemRelativeDisease(): void {
  console.log("Eliminando elemento con ID:", this.uniqueId);
  this.posSended.emit({ uniqueId: this.uniqueId }); // ← Emite ID, no posición
}

deleteItemSingle(): void {
  this.posSendedId.emit({ itemId: this.id }); // ← Emite ID, no posición
}


}
